import { Box, useClassNames } from '@factorialco/deprecated-design-system'

import * as stylesRefs from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/CoverageSection/index.vanilla.css'
import { ColumnsType } from 'modules/shift_management/components/ShiftManagement/Content/Body/DataTable/utils/buildColumns'

import CoverageSummary from './CoverageSummary'
import CoverageTitle from './CoverageTitle'

interface Props {
  columns: ColumnsType
}

const HeaderOld = ({ columns }: Props) => {
  const cx = useClassNames(stylesRefs)

  return (
    <Box
      background="grey100"
      width="full"
      height="s24"
      paddingY="s4"
      border={{
        top: { width: 's1', style: 'solid', color: 'grey300' },
        bottom: { width: 's1', style: 'solid', color: 'grey300' },
        right: { width: 's1', style: 'solid', color: 'grey300' },
      }}
      className={cx('header', 'sticky')}
    >
      <Box flexDirection="row" alignItems="center" width="full" height="full">
        <CoverageTitle />
        <CoverageSummary columns={columns} />
      </Box>
    </Box>
  )
}

export { HeaderOld }
